<template>
    <v-system-bar color="#00AAA2">
        <v-icon>mdi-square</v-icon>
        <v-icon>mdi-circle</v-icon>
        <v-icon>mdi-triangle</v-icon>
    </v-system-bar>
</template>

<script>


export default {
name: 'MobileStatsView',

components: {
    //
},

data: () => ({
    //
}),
}
</script>
  